import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function SearchBox({ onClose }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [trending, setTrending] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${apiUrl}/get-trendingcoin-data`)
      .then(res => res.json())
      .then(data => setTrending(data.coins.map(c => c.item)))
      .catch(err => console.error("Failed to fetch trending", err));
  }, []);

  useEffect(() => {
    if (query.trim() === "") return;
    const timer = setTimeout(() => {
      fetch(`${apiUrl}/get-searchcoin?query=${query}`)
        .then(res => res.json())
        .then(data => setResults(data.coins))
        .catch(err => console.error("Failed to search coins", err));
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const coinsToShow = query.length > 0 ? results : trending;

  return (
    <div className="popup">
      <div className="popup-header">
        <span>Search</span>
        <button onClick={onClose}>✕</button>
      </div>

      <input
        className="popup-search-input"
        type="text"
        value={query}
        placeholder="Search coin..."
        onChange={(e) => setQuery(e.target.value)}
        autoFocus
      />

      <div className="results">
        {coinsToShow.map((coin) => (
          <div
            key={coin.id}
            className="result-item"
            onClick={() => {
              navigate(`/coin/${coin.id}`);
              onClose();
            }}
          >
            <img src={coin.thumb || coin.small || coin.image} alt={coin.name} width={20} />
            <span>{coin.name} ({coin.symbol?.toUpperCase()})</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SearchBox;
